<template>
  <main class="flex w-full h-lvh">
    <div class="max-w-7xl flex-wrap lg:flex-nowrap mx-auto flex w-full justify-between ">
      <!-- Error content -->
      <div class="h-lvh error-desc w-full flex items-start z-10 flex-col justify-center px-8 order-2 lg:order-1">
        <span class="my-4 text-9xl error-code font-bold lg:opacity-55">404</span>
        <div class="separator my-4"></div>
        <span class="my-4 text-3xl">{{ $t('PAGE_NOT_FOUND') }}</span>
        <nuxt-link to="/" class="mb-2 font-bold">
          {{ $t('GO_TO_HOME') }}
        </nuxt-link>
      </div>
      <!-- Image cover -->
      <div class="fixed lg:relative top-0 right-0 z-0 order-1 lg:order-2">
        <img class="h-svh object-cover" src="https://assets.terreirovoritadasalmas.com.br/illustrations/hero-welcome.jpg" alt="">
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'default',
})

 const props = defineProps({
  error: Error,
 });
 console.log(`%c${props.error}`, "background-color: green");
</script>
<style lang="scss" scoped>
main {
  background-color: #fff;
}

.separator {
  height: 4px;
  width: 90px;
}

.error-code {
  font-size: 250px;
}

.error-desc {
  background-color: rgba(var(--theme-rgb), 0.85);
  color: #fff;

  .separator {
    background-color: #fff;
  }
}

// ---------------------------
// Responsive
// ---------------------------

@media (screen(lg)) {
  img {
    max-width: 600px;
  }

  .error-desc {
    background-color: unset;
    color: inherit;

    .separator {
      background-color: var(--theme);
    }
  }
}

</style>